import { render } from "./TextMessage.vue?vue&type=template&id=63b4e6d8&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=js"
export * from "./TextMessage.vue?vue&type=script&lang=js"

import "./TextMessage.vue?vue&type=style&index=0&id=63b4e6d8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b4e6d8"]])

export default __exports__